import { AxiosPromise } from 'axios';

// @ts-ignore
import { projectRequest } from 'store/utils/request';
import { UploadRequestData, UploadResponseData } from './types';

type ClustersResponseData = {
  clusters: string[];
};

export const fetchClustersRequest = (
  dashboardEnvId: string,
  password: string,
): AxiosPromise<ClustersResponseData> => {
  const params = {
    password,
  };
  return projectRequest.post<ClustersResponseData>(
    `/environments/${dashboardEnvId}/clusters/`,
    params,
  );
};

export const authenticateRequest = (dashboardEnvId: string, password: string) =>
  projectRequest.post(`/environments/${dashboardEnvId}/authenticate/`, {
    password,
  });

export const uploadProjectRequest = (
  environmentId: string,
  data: UploadRequestData,
): AxiosPromise<UploadResponseData> =>
  projectRequest.post(`/environments/${environmentId}/upload/`, {
    ...data,
  });
